var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShippingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113.08mm",
    height: "86.715mm",
    viewBox: "0 0 113.08 86.715",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.088 -89.434)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m132.29 106.4h-6.2761v-5.6541a11.308 11.308 0 0 0-11.308-11.308h-60.311a11.308 11.308 0 0 0-11.308 11.308v45.233a11.308 11.308 0 0 0 11.308 11.308h5.051a13.193 13.193 0 1 0 23.823 0h27.064a13.193 13.193 0 1 0 23.823 0h10.705a11.308 11.308 0 0 0 11.308-11.308v-16.962c0-12.477-10.705-22.616-23.879-22.616zm-81.664 39.579v-45.233a3.7694 3.7694 0 0 1 3.7694-3.7694h60.311a3.7694 3.7694 0 0 1 3.7694 3.7694v49.002h-64.08a3.7694 3.7694 0 0 1-3.7694-3.7694zm26.386 16.962a5.6541 5.6541 0 1 1-5.6541-5.6541 5.6541 5.6541 0 0 1 5.6541 5.6541zm50.887 0a5.6541 5.6541 0 1 1-5.6541-5.6541 5.6541 5.6541 0 0 1 5.6541 5.6541zm20.732-16.962a3.7694 3.7694 0 0 1-3.7694 3.7694h-18.847v-35.809h6.2761c9.0089 0 16.34 6.7661 16.34 15.078z",
    style: {
      fill: "#0c387a",
      strokeWidth: 1.8847
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.6 111.82-11.631-10.697c-0.61521-0.56592-1.5714-0.53148-2.1442 0.0771l-0.35905 0.38149c-0.58229 0.61868-0.54719 1.594 0.0782 2.1691l0.25027 0.23004-28.001 29.747c-1.2273 1.3036-1.8676 3.0073-1.8031 4.7967 0.06453 1.7893 0.82578 3.4424 2.1436 4.6545l1.4124 1.2993c1.2308 1.1319 2.8288 1.7551 4.4999 1.7551 1.8264 0 3.5916-0.76236 4.8427-2.0917l28.106-29.859 0.17949 0.16496c0.6152 0.56592 1.5714 0.53148 2.1443-0.0771l0.35904-0.38149c0.58226-0.61868 0.54718-1.594-0.0783-2.1691zm-16.664 14.218-10.294-4.9037 14.361-15.256 7.9916 7.3503z",
    style: {
      fill: "#0c387a",
      strokeWidth: 0.218
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingLogo);
export default __webpack_public_path__ + "static/media/shipping_logo.91a47747d70be2ed740bd8d3ba08b03a.svg";
export { ForwardRef as ReactComponent };